"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailCommunicationType = void 0;
var EmailCommunicationType;
(function (EmailCommunicationType) {
    EmailCommunicationType["Enabled"] = "enabled";
    EmailCommunicationType["Disabled"] = "disabled";
    EmailCommunicationType["Unknown"] = "unknown";
})(EmailCommunicationType || (exports.EmailCommunicationType = EmailCommunicationType = {}));
//# sourceMappingURL=index.js.map